<div class="confirm-mail-container">
    <h2>MonPharmacien</h2>
    <ng-container *ngIf="!isError(); else error">
        <p class="check-icon"><i class="far fa-check-circle"></i></p>
        <p>Votre adresse mail à été confirmée !</p>
        <p>Vous pouvez désormais vous connecter à l'application MonPharmacien.</p>
    </ng-container>
    <ng-template #error>
        <p class="error-icon"><i class="far fa-times-circle"></i></p>
        <p>{{errorMessage}}</p>
    </ng-template>
</div>